import { HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import {CONFIG} from '../helper/app-config'
import Swal from "sweetalert2";

export function getHeaders(){
    return new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": "Bearer "+ localStorage.getItem('access_token')
    });
}
  export function redirectToLandingPage() {
    Swal.fire({
      icon: "warning",
      title: " Session Expired,Redirecting to Landing Page !!!",
      showConfirmButton: false,
      timer: 4000,
    }).then(() => window.location.href = CONFIG.DOMAINPATH);
  }

  export function handleResponse (response : any){
    let response_ = JSON.parse(response);
    if(response_.code === 200){
      return response_.data;
    }else if(response_.code === 400){
      // let message=response_.data.toLowerCase()
      // if(message && message.includes('token')&& message.includes('expired')){
      //  redirectToLandingPage()
      // }
      // else{
      throw new Error(JSON.stringify(response_.data))
      // }
    }
    return response_;
  }

  export function handleFetchImageResponse(response:any){
    return response
  }

  export function handleUploadResponse (response : any){
    let response_ = response;
    if(response_.code === 200){
      return response_.data;
    }
    return response_;
  }

 

  export function handleUniqueNameCheckApiResponse (response : any){
    let response_ = JSON.parse(response);
    if(response_.code === 200){
      return response_.data;
    }
    return response_;
  }


export function handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    }else if(error.status === 500){
      console.log("error :: ", error)
    return throwError(error.statusText);
    }else if(error.status === 401){
      let error_ = JSON.parse(error.error);
      return throwError(error_.err_msg)
    }else if(error.status === 400){
      let error_ = JSON.parse(error.error);
      return throwError(error_)
    }
     else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error("error :: ",error)
    }
    // Return an observable with a user-facing error message.
    return throwError(error.message);
  }
